import { render } from "./ActivityTemplatePractical.vue?vue&type=template&id=23e39968"
import script from "./ActivityTemplatePractical.vue?vue&type=script&lang=js"
export * from "./ActivityTemplatePractical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__